
import React, { useContext, useEffect, useState, ChangeEvent } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from '../context/BasicContext'

type AnswerInputProp = {
    serial: number
    qName: string
    QSNo: number
    //jsonString: string
    defAns?: string
    isAnswered:boolean
    checker: () => {} | void
}

type AnswerItem = {
    ItemID: string,
    ItemTitle: string,
    ansID: string,
}


export default (props: AnswerInputProp) => {
    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)

    const [btns, setBtns] = useState<AnswerItem[]>([])
    const [current, setCurrent] = useState<string>("")

    useEffect(() => {
        if (props) {
            //const ans: AnswerItem[] = JSON.parse(quest.Answers) as AnswerItem[]
            //setBtns(JSON.parse(props.jsonString) as AnswerItem[])
            if (props.defAns) {
                setCurrent(props.defAns)
              //  console.log(props.defAns)
            }
        }

    }, [props, bc.ansList])

    const txtChange = (event: ChangeEvent<HTMLInputElement>) => {
        //console.log(event.target.value)
        //setCurrent(a.ItemID)


        const ans: ResAnswers = {
            QSNo: props.QSNo.toString(),
            qtxt: props.qName,
            ItemTxt: event.target.value,
        }

        let temp: ResAnswers[] = bc.ansList;
        temp[props.serial] = ans
        bc.setAnsList(temp)
        props.checker()
    }

    if (props.isAnswered) {
        return (
            <div style={{ marginBottom: 60 }}>
                您的回答：{props.defAns}
            </div>
        )
    } else {
        return (
            <div style={{ marginBottom: 60 }}>
                <input
                    defaultValue={props.defAns}
                    onChange={txtChange}
                />
            </div>
        )
    }
}

